export const environment = {
    production: false,
    cruiseCodeApiBaseUrl: 'https://apidev.cruisecode.com/',
    cruiseCodeEmailApiBaseUrl: 'https://emaildev.cruisecode.com/',
    signInSignUpUserFlow: 'B2C_1_SignInSignUp_Dev',
    signInSignUpAuthority:
        'https://cruisecode.b2clogin.com/cruisecode.onmicrosoft.com/B2C_1_SignInSignUp_Dev',
    signInSignUpCheckoutUserFlow: 'B2C_1_SignInSignUp_Checkout_Dev',
    signInSignUpCheckoutAuthority:
        'https://cruisecode.b2clogin.com/cruisecode.onmicrosoft.com/B2C_1_SignInSignUp_Checkout_Dev',
    signInSignUpReviewUserFlow: 'B2C_1_SignInSignUp_Review_Dev',
    signInSignUpReviewAuthority:
        'https://cruisecode.b2clogin.com/cruisecode.onmicrosoft.com/B2C_1_SignInSignUp_Review_Dev',
    signInROPCFirstTimeCheckoutUserFlow:
        'https://cruisecode.b2clogin.com/cruisecode.onmicrosoft.com/B2C_1_SignInROPCFirstTimeCheckout',
    signInROPCFirstTimeCheckoutAuthority: 'B2C_1_SignInROPCFirstTimeCheckout',
    cartLocalStorageVersion: '1.3',

    // Azure AD auth via Cap plugin
    capacitorAzureConfig: {
        appId: '0471f107-0166-4098-a546-40f9ec89f5fe', // clientId
        // https://learn.microsoft.com/en-us/azure/azure-portal/get-subscription-tenant-id#find-your-azure-ad-tenant
        tenantId: '2c99a69e-eb33-4680-b07c-e813b31b77f2',
        web: {
            redirectUrl: 'https://angulardev.cruisecode.com/auth',
        },
        android: {
            // [IMPORTANT] we also need to set the hash in strings.xml
            // it doesn't change between environments, so we can leave it there
            redirectUrl:
                'msauth://app.cruisecode.dtd/N7bW5TFz7S0GRMxMr5mfEvhnkuE%3D',
        },
        ios: {
            redirectUrl: 'msauth.app.cruisecode.dtd://auth',
        },
    },
};
